export default __webpack_public_path__ + "static/media/add-image.e7341d30.svg";